import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import axios from "axios";
import { RequestPWDURL } from "../../../Library/URLs";
import { generateTransactionID } from "../../../Library/Utilities";
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LocalShipmentActions } from '../../../store/Local_Slice';

const RequestPWD = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useDispatch();
    const form = useRef(null);

    const loginUser = (e) => {
        e.preventDefault();

        const data = new FormData(form.current);
        const formValues = {};

        for (let [key, value] of data.entries()) {
            formValues[key] = value;
        }
        formValues["company_id"] = "44";
        formValues["transaction_id"] = generateTransactionID(15);

        setIsSubmitting(true);

        axios
            .post(RequestPWDURL, formValues)
            .then(function (response) {
                if (response["data"]["success"] === false) {
                    setIsSubmitting(false);
                    toast.error(response["data"]["message"]);
                } else if (response["data"]["success"] === true) {
                    dispatch(LocalShipmentActions.GetResetCode(response["data"]));
                    dispatch(LocalShipmentActions.GetResetStatus(true));
                    setIsSubmitting(false);
                    toast.success('A reset code has been sent to your registered email');
                }
            })
            .catch(function (error) {
                setIsSubmitting(false);
                return error;
            });
    };


    return (
        <div className="Login_Form">
        <h3>Let's get started</h3>
        <p>To continue, please provide a valid details.</p>
        <form ref={form} onSubmit={loginUser}>
            <div className="Box Request">
                <input placeholder="Enter email" name="email" />
            </div>
            <Link className="Forgot_Text" to="/login">Already have an account</Link>

            <div className="Terms">
                By completing this transaction, you represent that you have read, understand and accept the
                Zee Express <Link to="/login">terms of service</Link> and <Link to="/login">privacy policy</Link>.
            </div>

            <button type="submit" className="Btn">
                {isSubmitting === false ? (
                    <span className="button-text">SEND</span>
                ) : (
                    <span className="spinner-border spinner-grow-sm"/>
                )}
            </button>
        </form>
    </div>
    );
}
 
export default RequestPWD;